/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Adds nested create feature
 * @export
 * @interface CustomQuestionnaireAnswerOption
 */
export interface CustomQuestionnaireAnswerOption {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswerOption
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswerOption
   */
  order?: number;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireAnswerOption
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireAnswerOption
   */
  info?: string | null;
}

/**
 * Check if a given object implements the CustomQuestionnaireAnswerOption interface.
 */
export function instanceOfCustomQuestionnaireAnswerOption(value: object): value is CustomQuestionnaireAnswerOption {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('value' in value) || value['value'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireAnswerOptionFromJSON(json: any): CustomQuestionnaireAnswerOption {
  return CustomQuestionnaireAnswerOptionFromJSONTyped(json, false);
}

export function CustomQuestionnaireAnswerOptionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireAnswerOption {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    order: json['order'] == null ? undefined : json['order'],
    value: json['value'],
    info: json['info'] == null ? undefined : json['info'],
  };
}

export function CustomQuestionnaireAnswerOptionToJSON(value?: Omit<CustomQuestionnaireAnswerOption, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    order: value['order'],
    value: value['value'],
    info: value['info'],
  };
}
